var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9165 6.83325H9.74984C8.93209 6.83325 8.14783 7.16688 7.56959 7.76075C6.99135 8.35461 6.6665 9.16007 6.6665 9.99992V28.9999C6.6665 29.8398 6.99135 30.6452 7.56959 31.2391C8.14783 31.833 8.93209 32.1666 9.74984 32.1666H28.2498C29.0676 32.1666 29.8518 31.833 30.4301 31.2391C31.0083 30.6452 31.3332 29.8398 31.3332 28.9999V22.6666M18.9998 19.4999L31.3332 6.83325M31.3332 6.83325V14.7499M31.3332 6.83325H23.6248",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.28e4c48fa58cb63497eda1768fbd5cb1.svg";
export { ForwardRef as ReactComponent };